"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeCartCb = exports.changeCart = void 0;
var queue_1 = require("./queue");
var events_1 = require("./events");
var jquery_1 = require("../jquery");
//Promise
var changeCart = function (changes) {
    return new Promise(function (resolve, reject) {
        (0, exports.changeCartCb)(changes, resolve, reject);
    });
};
exports.changeCart = changeCart;
var changeCartCb = function (changes, callback, errorCallback) {
    if (!Array.isArray(changes))
        changes = [changes];
    var updates = changes.reduce(function (x, c) {
        var v = c.variant || c.key;
        var q = c.quantity;
        x[v] = q;
        return x;
    }, {});
    var o = {
        updates: updates,
        callback: callback,
        errorCallback: errorCallback,
        url: '/cart/update.js',
        dataType: "json",
        method: 'POST',
        data: { updates: updates },
        action: 'change'
    };
    o.success = function (data) {
        if (this.callback)
            this.callback(data);
        (0, queue_1.addFinishTrigger)({ event: events_1.ON_ITEM_CHANGED, data: data });
        (0, queue_1.removeTask)(this);
        (0, queue_1.nextTask)();
    }.bind(o);
    o.error = function (e, i, a) {
        if (typeof this.errorCallback === "function") {
            this.errorCallback(e ? e.responseJSON || e : 'Unknown Error');
        }
        (0, queue_1.removeTask)(this);
        (0, queue_1.errorQueue)();
    }.bind(o);
    o.task = function () {
        jquery_1.jq.ajax(this);
    }.bind(o);
    (0, queue_1.addTask)(o);
};
exports.changeCartCb = changeCartCb;
//# sourceMappingURL=change.js.map